import React, {useContext, useEffect, useMemo, useState} from 'react';

import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Paper, Badge
} from "@mui/material";
import Grid from '@mui/material/Grid';

import {useNavigate} from "react-router-dom";
import Typography from "@mui/material/Typography";
import './activities.css';
import ActivitiesCard from "./ActivitiesCard";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import IconButton from "@mui/material/IconButton";
import InfoActivities from "../../Dialogs/InfoActivities";
import {Stack} from "@mui/system";
import {PAContext} from "../../../Services/PAContext";



function ActivitiesList(props) {

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { sendSocketMessage } = useContext(PAContext);

    const eventActivities = useMemo(() => {
        return PA_GlobalObject?.Planning?.activities ?? [];
    }, [PA_GlobalObject?.Planning?.activities]);

    const [filteredActivities, setFilteredActivities] = useState([]);

    const [viewType, setViewType] = useState(
        usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0 ?
            'dates'
            : usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.length > 0 ?
                'days' : 'dates'); // Either 'dates' or 'days'
    const [eventHasDates, setEventHasDates] = useState(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0);
    const [eventHasDays, setEventHasDays] = useState(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.length > 0);
    const [selectedDate, setSelectedDate] = useState('all'); // For selected date
    const [selectedDay, setSelectedDay] = useState('all'); // For selected day

    // Toggle visibility of dates or days chips
    const handleToggleViewType = () => {
        console.log("handleToggleViewType : " + viewType);

        const planning = usePA_GlobalStore.getState().PA_GlobalObject.Planning;
        const eventDays = planning.time_table?.days || [];
        const eventDates = planning.time_table?.dates || [];

        if (viewType === 'dates') {
            console.log("Changing Chips to days...");

            if (selectedDate === 'all') {
                setSelectedDay('all'); // Show all meals if "all" was selected
            } else {
                // Find the corresponding day for the selected date
                const correspondingDay = eventDates.find(dateEntry => dateEntry.date === selectedDate);
                if (correspondingDay) {
                    const dayIndex = eventDates.indexOf(correspondingDay);
                    const correspondingDayKey = Object.keys(eventDays[dayIndex] || {})[0] || 'all';
                    setSelectedDay(correspondingDayKey);
                } else {
                    setSelectedDay('all'); // Fallback
                }
            }

            setViewType('days');

        } else if (viewType === 'days') {
            console.log("Changing Chips to dates...");

            if (selectedDay === 'all') {
                setSelectedDate('all'); // Show all meals if "all" was selected
            } else {
                // Find the corresponding date for the selected day
                const correspondingDayEntry = eventDays.find(dayEntry => Object.keys(dayEntry)[0] === selectedDay);
                if (correspondingDayEntry) {
                    const dayIndex = eventDays.indexOf(correspondingDayEntry);
                    const correspondingDate = eventDates[dayIndex]?.date || 'all';
                    setSelectedDate(correspondingDate);
                } else {
                    setSelectedDate('all'); // Fallback
                }
            }

            setViewType('dates');
        }
    };

    const handleAddNewActivityDirect = () => {
        navigate('/Planner/Activities/Add');
    };
    const [anchorActivitiesListMenu, setAnchorActivitiesListMenu] = useState(null);
    const handleActivitiesListMenuOpenMenu = (event) => {
        setAnchorActivitiesListMenu(event.currentTarget);
    };
    const handleActivitiesListMenuClick = (event) => {
        const target = event.currentTarget;
        const dataId = target.getAttribute('data-id');

        handleActivitiesListMenuClose();

        if (dataId === "new-entry"){
            navigate('/Planner/Activities/Add');
        }
    };
    const handleActivitiesListMenuClose = () => {
        setAnchorActivitiesListMenu(null);
    };


    useEffect(() => {
        if ((viewType === 'dates' && selectedDate === 'all') || (viewType === 'days' && selectedDay === 'all')){
            handleActivityChipAllClick();
        } else {
            //need to decide whether to update the filtered list



        }
    }, [eventActivities]);

    function handleActivityChipAllClick(){
        console.log("handleActivityChipAllClick : ", eventActivities);

        setSelectedDate('all');
        setSelectedDay('all');

        let filtered = [...eventActivities];

        // Sort activities by the date and then the begin time (if available)
        filtered = filtered.sort((a, b) => {

            // Extract begin_time for both activities, defaulting to '00:00' if not found
            const timeA = a.time_table.dates?.[0]?.begin_time || a.time_table.days?.[0]?.begin_time || '12:00 AM';
            const timeB = b.time_table.dates?.[0]?.begin_time || b.time_table.days?.[0]?.begin_time || '12:00 AM';

            // Extract the date or day (if date is present, use it, otherwise use a placeholder date with the day's index)
            const dateA = a.time_table.dates?.[0]?.date
                || (Array.isArray(a.time_table.days) && a.time_table.days[0]
                    ? dayjs().day(Object.keys(a.time_table.days[0])[0].replace('day ', '')).format('YYYY-MM-DD')
                    : null);
            const dateB = b.time_table.dates?.[0]?.date
                || (Array.isArray(b.time_table.days) && b.time_table.days[0]
                    ? dayjs().day(Object.keys(b.time_table.days[0])[0].replace('day ', '')).format('YYYY-MM-DD')
                    : null);


//            const dateA = a.time_table.dates?.[0]?.date || dayjs().day(Object.keys(a.time_table.days?.[0])[0].replace('day ', '')).format('YYYY-MM-DD');
//            const dateB = b.time_table.dates?.[0]?.date || dayjs().day(Object.keys(b.time_table.days?.[0])[0].replace('day ', '')).format('YYYY-MM-DD');

            // Combine date and time for comparison
            const dateTimeA = dayjs(`${dateA} ${timeA}`, 'YYYY-MM-DD HH:mm A');
            const dateTimeB = dayjs(`${dateB} ${timeB}`, 'YYYY-MM-DD HH:mm A');

            // Compare the combined date and time
            return dateTimeA.diff(dateTimeB);
        });

        setFilteredActivities(filtered);
    }
    function handleActivityChipDateClick(_activity_date) {
        console.log("handleActivityChipDateClick : " + _activity_date);

        if (viewType !== "dates") {
            setViewType("dates");
        }
        setSelectedDate(_activity_date);
        setSelectedDay(''); // Clear day selection to keep the "All" highlight logic clean

        // 1. Filter: Use .some() to check ALL date entries for this activity
        let filtered = eventActivities.filter(activity => {
            const datesArray = activity.time_table?.dates;
            if (!datesArray || !Array.isArray(datesArray)) return false;

            // Returns true if the specific date exists anywhere in the activity's plan
            return datesArray.some(d => d.date === _activity_date);
        });

        // 2. Robust Sort: Handle multi-date crossovers and missing times
        filtered = filtered.sort((a, b) => {
            // Find the specific entry for the date we are currently viewing
            const entryA = a.time_table.dates.find(d => d.date === _activity_date);
            const entryB = b.time_table.dates.find(d => d.date === _activity_date);

            // Fallbacks: 12:00 AM if no start time, 11:59 PM if no end time
            const startA = entryA?.begin_time || '12:00 AM';
            const startB = entryB?.begin_time || '12:00 AM';

            const endA = entryA?.end_time || '11:59 PM';
            const endB = entryB?.end_time || '11:59 PM';

            // We use the clicked date with the time for a solid Dayjs object
            const momentStartA = dayjs(`${_activity_date} ${startA}`, 'YYYY-MM-DD h:mm A');
            const momentStartB = dayjs(`${_activity_date} ${startB}`, 'YYYY-MM-DD h:mm A');

            // Primary Sort: Start Time
            if (!momentStartA.isSame(momentStartB)) {
                return momentStartA.diff(momentStartB);
            }

            // Secondary Sort: End Time
            const momentEndA = dayjs(`${_activity_date} ${endA}`, 'YYYY-MM-DD h:mm A');
            const momentEndB = dayjs(`${_activity_date} ${endB}`, 'YYYY-MM-DD h:mm A');
            return momentEndA.diff(momentEndB);
        });

        console.log("Filtered Activities for " + _activity_date + ": ", filtered.length);
        setFilteredActivities(filtered);
    }
    function handleActivityChipDayClick(_activity_day) {
        console.log("handleActivityChipDayClick : " + _activity_day);

        if (viewType !== "days") setViewType("days");
        setSelectedDay(_activity_day);
        setSelectedDate('');

        // 1. Filter: Same logic, find if the activity is assigned to this day slot
        let filtered = eventActivities.filter(activity => {
            const daysArray = activity.time_table?.days;
            return Array.isArray(daysArray) && daysArray.some(d => _activity_day in d);
        });

        // 2. Robust Sort: Handle missing start/end times
        filtered = filtered.sort((a, b) => {
            const entryA = a.time_table.days.find(d => _activity_day in d);
            const entryB = b.time_table.days.find(d => _activity_day in d);

            // Fallback: If no begin_time, treat as 12:00 AM (start of day)
            // Fallback: If no end_time, treat as 11:59 PM (end of day)
            const startA = entryA?.begin_time || '12:00 AM';
            const startB = entryB?.begin_time || '12:00 AM';

            const endA = entryA?.end_time || '11:59 PM';
            const endB = entryB?.end_time || '11:59 PM';

            const momentStartA = dayjs(startA, 'h:mm A');
            const momentStartB = dayjs(startB, 'h:mm A');

            // Primary sort: Begin Time
            if (!momentStartA.isSame(momentStartB)) {
                return momentStartA.diff(momentStartB);
            }

            // Secondary sort: End Time (if start times are the same)
            const momentEndA = dayjs(endA, 'h:mm A');
            const momentEndB = dayjs(endB, 'h:mm A');
            return momentEndA.diff(momentEndB);
        });

        setFilteredActivities(filtered);
    }


    const [activityToDelete, setActivityToDelete] = useState(null);  // Holds the activity to delete for confirmation dialog
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);  // Controls the confirmation dialog visibility
    const handleDeleteActivity = (activityId) => {
        if (!activityId) return;

        const updatedActivities = eventActivities.filter(activity => {
            if (!activity) return false;
            return String(activity.id) !== String(activityId) &&
                String(activity.temp_id) !== String(activityId);
        });

        set_PA_GlobalObject((prev) => ({
            ...prev, // Keep root level objects secure
            Planning: {
                ...prev?.Planning, // Retain all existing fields in Planning
                activities: updatedActivities,
            },
        }));

        if (PA_GlobalObject?.Planning?.status !== 10) {
            const _sendString = {
                action: "E_deleteEventActivity_v2",
                event_id: PA_GlobalObject?.Planning?.id,
                activity_id: activityId // The backend handler will catch this string token
            };

            sendSocketMessage(_sendString);
        }

        // 5. Secure UI state flags
        closeDeleteDialog();
    };
    const openDeleteDialog = (activity) => {
        setActivityToDelete(activity);  // Set the activity to be deleted
        setDeleteDialogOpen(true);  // Open the confirmation dialog
    };
    const closeDeleteDialog = () => {
        setActivityToDelete(null);  // Reset the activity to be deleted
        setDeleteDialogOpen(false);  // Close the confirmation dialog
    };

    const [isActivityInfoDialogOpen, setActivityInfoDialogOpen] = useState(false);




    return (

        <div className="activities-list-container" >

            {/* --- ACTIVITY LIST HEADER --- */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    {/* Title Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', // Amber/Gold Gradient
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(245, 158, 11, 0.3)'
                        }}>
                            <i className="icon-list-heart" style={{ color: 'white', fontSize: '18px' }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', letterSpacing: -0.4 }}>
                                Activities
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <i className="icon-info-circle"
                                   style={{ color: '#f59e0b', fontSize: '10px', cursor: 'pointer' }}
                                   onClick={() => setActivityInfoDialogOpen(true)}
                                />
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 700, fontSize: '0.65rem' }}>
                                    Experience & Plan
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    {/* Controls Area */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                        {/* Segmented View Toggle (Dates/Days) */}
                        <Box sx={{
                            display: 'flex',
                            bgcolor: '#f1f5f9',
                            p: 0.5,
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0'
                        }}>
                            <Box
                                onClick={() => viewType !== 'dates' && handleToggleViewType()}
                                sx={{
                                    px: 1.5, py: 0.5, borderRadius: '8px', cursor: 'pointer',
                                    bgcolor: viewType === 'dates' ? '#fff' : 'transparent',
                                    boxShadow: viewType === 'dates' ? '0 2px 6px rgba(0,0,0,0.06)' : 'none',
                                    transition: '0.2s',
                                    display: 'flex', alignItems: 'center'
                                }}
                            >
                                <Typography sx={{
                                    fontSize: '10px',
                                    fontWeight: 800,
                                    color: viewType === 'dates' ? '#d97706' : '#64748b'
                                }}>
                                    DATES
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => viewType !== 'days' && handleToggleViewType()}
                                sx={{
                                    px: 1.5, py: 0.5, borderRadius: '8px', cursor: 'pointer',
                                    bgcolor: viewType === 'days' ? '#fff' : 'transparent',
                                    boxShadow: viewType === 'days' ? '0 2px 6px rgba(0,0,0,0.06)' : 'none',
                                    transition: '0.2s',
                                    display: 'flex', alignItems: 'center'
                                }}
                            >
                                <Typography sx={{
                                    fontSize: '10px',
                                    fontWeight: 800,
                                    color: viewType === 'days' ? '#d97706' : '#64748b'
                                }}>
                                    DAYS
                                </Typography>
                            </Box>
                        </Box>

                        <IconButton
                            onClick={handleAddNewActivityDirect}
                            sx={{
                                bgcolor: '#1e293b',
                                color: 'white',
                                borderRadius: '12px',
                                width: '38px',
                                height: '38px',
                                boxShadow: '0 4px 12px rgba(30, 41, 59, 0.25)',
                                transition: 'all 0.2s ease',
                                '&:hover': { bgcolor: '#334155', transform: 'scale(1.05)' },
                                '&:active': { transform: 'scale(0.95)' }
                            }}
                        >
                            <i className="icon-plus" style={{ fontSize: '20px' }} />
                        </IconButton>
                    </Box>
                </Box>
            </Paper>

            {/* --- ACTIVITIES TIMETABLE NAVIGATION --- */}
            <Box
                className="activities-list-timetable-list-container"
                sx={{
                    display: 'flex',            // Use flexbox
                    flexDirection: 'row',       // Align children in a row
                    flexWrap: 'nowrap',         // CRITICAL: Prevents chips from jumping to the next line
                    overflow: 'auto',
                    gap: 1.5,                   // Consistent spacing between your new DateTabs
                    py: 2,                      // Padding for the "hover lift" and badges
                    px: 1,
                }}
            >
                {/* 1. "ALL" Selection Card */}
                {(eventHasDates || eventHasDays) && (
                    <Box
                        onClick={handleActivityChipAllClick}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            cursor: 'pointer',
                            minWidth: '60px',
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <Box sx={{
                            width: 45,
                            height: 50,
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: (viewType === 'dates' ? selectedDate === 'all' : selectedDay === 'all')
                                ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
                                : '#fff',
                            border: (viewType === 'dates' ? selectedDate === 'all' : selectedDay === 'all')
                                ? 'none'
                                : '1px solid #e2e8f0',
                            boxShadow: (viewType === 'dates' ? selectedDate === 'all' : selectedDay === 'all') ? '0 4px 12px rgba(217, 119, 6, 0.3)' : 'none',
                            transition: 'all 0.3s ease'
                        }}>
                            <Typography sx={{
                                fontWeight: 900,
                                fontSize: '0.75rem',
                                color: (viewType === 'dates' ? selectedDate === 'all' : selectedDay === 'all')
                                    ? '#fff'
                                    : '#64748b'
                            }}>
                                ALL
                            </Typography>
                        </Box>
                    </Box>
                )}

                {/* 2. DATES View Type */}
                {viewType === 'dates' && eventHasDates ? (
                    PA_GlobalObject.Planning['time_table'].dates.map((eventDateObj) => {
                        const eventDate = eventDateObj.date;
                        const isSelected = selectedDate === eventDate;
                        const dayName = dayjs(eventDate).format('ddd').toUpperCase();
                        const dateNum = dayjs(eventDate).format('D');

                        // Adjust this filter to match your Activity data structure
                        const activityCount = eventActivities.filter(act =>
                            act.time_table?.dates?.some(d => d.date === eventDate)
                        ).length;

                        return (
                            <Box
                                key={`act-date-${eventDate}`}
                                onClick={() => handleActivityChipDateClick(eventDate)}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    minWidth: '60px',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <Badge
                                    badgeContent={activityCount > 0 ? activityCount : null}
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            backgroundColor: '#fef3c7', // Soft Amber
                                            color: '#92400e',           // Dark Amber text
                                            fontSize: '10px',
                                            fontWeight: 900,
                                            border: '2px solid #fff',
                                            top: 4,
                                            right: 4
                                        },
                                    }}
                                >
                                    <Box sx={{
                                        width: 45,
                                        height: 50,
                                        borderRadius: '12px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: isSelected
                                            ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
                                            : '#fff',
                                        border: isSelected ? 'none' : activityCount === 0 ? '1px dashed #cbd5e1' : '1px solid #e2e8f0',
                                        boxShadow: isSelected ? '0 4px 12px rgba(217, 119, 6, 0.3)' : 'none',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        <Typography sx={{
                                            fontSize: '10px',
                                            fontWeight: 800,
                                            color: isSelected ? 'rgba(255,255,255,0.8)' : '#94a3b8',
                                            lineHeight: 1
                                        }}>
                                            {dayName}
                                        </Typography>
                                        <Typography sx={{
                                            fontSize: '1.1rem',
                                            fontWeight: 900,
                                            color: isSelected ? '#fff' : '#1e293b',
                                            lineHeight: 1.2
                                        }}>
                                            {dateNum}
                                        </Typography>
                                    </Box>
                                </Badge>
                            </Box>
                        );
                    })
                ) : viewType === 'days' && eventHasDays ? (
                    /* 3. DAYS View Type */
                    PA_GlobalObject.Planning['time_table'].days.map((dayObj) => {
                        const dayKey = Object.keys(dayObj).find(k => k.toLowerCase().startsWith('day')) || 'all';

                        // Extract the number from "day 1", "day 2", etc.
                        const dayNumber = dayKey.toLowerCase().replace('day', '').trim();

                        const dayName = dayObj[dayKey];
                        const isSelected = selectedDay === dayKey;

                        const activityCount = eventActivities.filter(act =>
                            // Check if the activity has a 'days' array
                            act.time_table?.days?.some(d => dayKey in d)
                        ).length;

                        return (
                            <Box
                                key={`act-day-${dayNumber}`}
                                onClick={() => handleActivityChipDayClick(dayKey)}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    minWidth: '65px',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <Badge
                                    badgeContent={activityCount > 0 ? activityCount : null}
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            backgroundColor: '#fef3c7',
                                            color: '#92400e',
                                            fontSize: '10px',
                                            fontWeight: 900,
                                            border: '2px solid #fff',
                                            top: 4,
                                            right: 4
                                        }
                                    }}
                                >
                                    <Box sx={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: '12px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: isSelected
                                            ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'
                                            : '#fff',
                                        border: isSelected ? 'none' : '1px solid #e2e8f0',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        <Typography sx={{
                                            fontSize: '10px',
                                            fontWeight: 800,
                                            color: isSelected ? 'rgba(255,255,255,0.8)' : '#94a3b8'
                                        }}>
                                            DAY
                                        </Typography>
                                        <Typography sx={{
                                            fontSize: '0.85rem',
                                            fontWeight: 900,
                                            color: isSelected ? '#fff' : '#1e293b'
                                        }}>
                                            {dayNumber}
                                        </Typography>
                                    </Box>
                                </Badge>
                            </Box>
                        );
                    })
                ) : null}
            </Box>


            {/* show the list of activities */}
            <div
                className={
                    props.showingPageHeader
                        ? "activities-list-items-container with-header"
                        : "activities-list-items-container"
                }
            >

                {
                    filteredActivities.length > 0 ? (
                        filteredActivities
                            .map((activityDetails, index) => (

                                <Grid
                                    item
                                    key={activityDetails.id}
                                    sx={{
                                        display: 'block',
                                        marginBottom: '10px'
                                    }}
                                >
                                    <ActivitiesCard
                                        activity={activityDetails}
                                        onDeleteActivity={() => openDeleteDialog(activityDetails)}
                                        _global_map_ref={props._global_map_ref}
                                    />

                                </Grid>

                            ))
                    ) : (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                py: 3,
                                px: 3,
                                mx: 'auto',
                                maxWidth: '450px',
                                borderRadius: '24px',
                                background: 'rgba(255, 255, 255, 0.6)',
                                backdropFilter: 'blur(10px)',
                                border: '2px dashed #d1fae5', // Soft Emerald dashed border
                                textAlign: 'center',
                            }}
                        >
                            {/* Amber Adventure Icon */}
                            <Box
                                sx={{
                                    width: 85,
                                    height: 85,
                                    borderRadius: '22px',
                                    background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 3,
                                    boxShadow: '0 12px 24px -6px rgba(217, 119, 6, 0.3)',
                                    transform: 'rotate(-3deg)'
                                }}
                            >
                                <i className="icon-compass2" style={{ fontSize: '40px', color: 'white' }} />
                            </Box>

                            {/* Header Content */}
                            <Typography variant="h5" sx={{ fontWeight: 900, color: '#1e293b', mb: 1, letterSpacing: '-0.03em' }}>
                                Adventure Awaits!
                            </Typography>

                            <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500, mb: 4, lineHeight: 1.6, px: 2 }}>
                                Your itinerary is looking a bit quiet. Whether it's a hidden hike or a local museum, let's get your first activity scheduled.
                            </Typography>

                            {/* Suggestion Info Tiles (Static/Non-Clickable) */}
                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: 1.5,
                                width: '100%',
                                mb: 4
                            }}>
                                <Box sx={{
                                    p: 1.5,
                                    bgcolor: 'rgba(255,255,255,0.4)',
                                    borderRadius: '16px',
                                    border: '1px solid #f1f5f9',
                                    textAlign: 'left'
                                }}>
                                    <Typography variant="caption" sx={{ fontWeight: 900, color: '#d97706', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <i className="icon-map-marker" /> EXPLORE
                                    </Typography>
                                    <Typography variant="caption" sx={{ display: 'block', color: '#64748b', mt: 0.5, fontSize: '0.65rem', lineHeight: 1.2 }}>
                                        Search the map for local points of interest.
                                    </Typography>
                                </Box>
                                <Box sx={{
                                    p: 1.5,
                                    bgcolor: 'rgba(255,255,255,0.4)',
                                    borderRadius: '16px',
                                    border: '1px solid #f1f5f9',
                                    textAlign: 'left'
                                }}>
                                    <Typography variant="caption" sx={{ fontWeight: 900, color: '#d97706', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <i className="icon-receipt" /> AI CONCIERGE
                                    </Typography>
                                    <Typography variant="caption" sx={{ display: 'block', color: '#64748b', mt: 0.5, fontSize: '0.65rem', lineHeight: 1.2 }}>
                                        Upload a receipt or PDF to extract details.
                                    </Typography>
                                </Box>
                            </Box>

                            {/* The One True Link / Primary CTA */}
                            <Button
                                variant="contained"
                                onClick={() => navigate('/Planner/Activities/Add')}
                                startIcon={<i className="icon-plus" style={{ fontSize: '14px' }} />}
                                sx={{
                                    borderRadius: '16px',
                                    textTransform: 'none',
                                    fontWeight: 800,
                                    bgcolor: '#d97706',
                                    py: 1.5,
                                    fontSize: '0.95rem',
                                    boxShadow: '0 8px 20px -4px rgba(217, 119, 6, 0.4)',
                                    '&:hover': {
                                        bgcolor: '#b45309',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 12px 24px -4px rgba(217, 119, 6, 0.5)',
                                    },
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                Add Your First Activity
                            </Button>
                        </Box>
                    )

                }
            </div>

            {/* Confirmation Dialog */}
            <Dialog
                open={isDeleteDialogOpen}
                onClose={closeDeleteDialog}
                // Added maxWidth and fullWidth for better mobile and desktop display
                maxWidth="sm"
                // Optional: Add a class for custom styling if needed
                PaperProps={{ sx: { borderRadius: "20px" } }}
            >
                {/* Use a Box for the content to apply padding, alignment, and styling */}
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    {/* Icon for the header */}
                    <Box
                        sx={{
                            display: 'inline-flex',
                            bgcolor: 'rgb(250,227,225)',
                            p: 2,
                            borderRadius: '50%',
                            mb: 2,
                        }}
                    >
                        <i className="icon-warning" style={{color: 'rgb(211, 47, 47)', fontSize: '40px'}}/>
                    </Box>

                    {/* Title */}
                    <DialogTitle
                        id="delete-modal-title"
                        variant="h4"
                        component="h2"
                        fontWeight="bold"
                        sx={{ color: 'text.primary', m: 0, p: 0 }}
                    >
                        A Moment of Caution
                    </DialogTitle>

                    {/* Body Text */}
                    <DialogContent sx={{ p: 0, '&:first-of-type': { pt: 0 } }}>
                        <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.6 }}>
                            <Box component="span" sx={{ fontWeight: 'bold', color: 'error.dark' }}>Heads up!</Box> Deleting this activity will remove it
                            <Box component="span" sx={{ fontWeight: 'bold', color: 'error.dark' }}> for everyone in the event</Box>, and this action
                            <Box component="span" sx={{ fontWeight: 'bold', color: 'error.dark' }}> cannot be undone</Box>.
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.6 }}>
                            This may also impact any associated costs and receipts. If a participant no longer wants to attend this activity, they can simply remove themselves on the activity's attendee tab without having to delete it for everyone.
                        </Typography>
                        <Typography variant="body1" sx={{ mt: 3, fontWeight: 'bold', color: 'text.primary' }}>
                            Are you sure you want to delete the activity "{activityToDelete?.title || activityToDelete?.location?.name}"?
                        </Typography>
                    </DialogContent>

                    {/* Buttons */}
                    <DialogActions sx={{ p: 0, mt: 4, justifyContent: 'center' }}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
                            <Button
                                onClick={closeDeleteDialog}
                                variant="contained"
                                sx={{
                                    color: 'text.primary',
                                    bgcolor: 'grey.300',
                                    '&:hover': {
                                        bgcolor: 'grey.400',
                                    },
                                    borderRadius: '10px',
                                    boxShadow: 3,
                                    flexGrow: 1,
                                }}
                            >
                                No, Keep It
                            </Button>
                            <Button
                                onClick={() => handleDeleteActivity(activityToDelete.id)}
                                variant="contained"
                                sx={{
                                    bgcolor: 'error.dark',
                                    '&:hover': {
                                        bgcolor: 'error.main',
                                    },
                                    borderRadius: '10px',
                                    boxShadow: 3,
                                    flexGrow: 1,
                                }}
                            >
                                Yes, Delete Activity
                            </Button>
                        </Stack>
                    </DialogActions>
                </Box>
            </Dialog>


            <InfoActivities
                isOpen={isActivityInfoDialogOpen}
                onClose={() => setActivityInfoDialogOpen(false)}
            />

        </div>
    )

}

export default ActivitiesList;
